import DetailsGroup from "@/components/DetailsPage/DetailsGroup";
import { PulseComponent } from "@pulsex/types";
import dynamic from "next/dynamic";
import { ComponentType } from "react";

const widgetStylesRegistry: Record<string, PulseComponent> = {
    "base-carousel": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    }, // should be used like this in cms
    "Home/Ticker": {
        Component: dynamic(
            () => import("@/components/BreakingNews/BreakingNews")
        ),
    },
    "Home/GridFeatured": {
        Component: dynamic(
            () => import("@/components/shared/Grids/MainGrid/MainGrid")
        ),
    },
    "Home/EditorsPick": {
        Component: dynamic(() => import("@/components/shared/Grids/BlockGrid")),
    },
    "Home/MostRead": {
        Component: dynamic(() => import("@/components/MostReadCarousel")),
    },
    "Home/ArtsSwiper": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    "Home/EconomySwiper": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    "Home/InfographGrids": {
        Component: dynamic(() => import("@/components/InfoGraphsSection")),
    },
    "Home/TechnologySwiper": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    "Home/SportsSwiper": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },

    "List/List": { Component: dynamic(() => import("@/components/GenreCard")) },

    FeaturedSlider: {
        Component: dynamic(() => import("@/components/NewsPage/FeatureSlider")),
    },
    Swiper: {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    SideSwiper: {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    Trending: {
        Component: dynamic(
            () => import("@/components/NewsPage/TrendingStories")
        ),
    },
    BlueSwiper: {
        Component: dynamic(() => import("@/components/NewsPage/BlueSwiper")),
    },
    ForYou: {
        Component: dynamic(
            () => import("@/components/shared/Grids/BlockGrid")
        ),
        props: {
            itemsPerRow: 4,
            author: false,
            replaceMoreLinkWithAuthorLink: true
        }
    },
    // category page
    FeaturedNews: {
        Component: dynamic(() => import("@/components/CategoriesPageMainGrid")),
    },
    FourCarousel: {
        Component: dynamic(() => import("@/components/CategoriesFeaturedGrid")),
    }, // TODO: style name to be changed
    TwoList: {
        Component: dynamic(() => import("@/components/CategoriesInfiniteList")),
    }, // TODO: style name to be changed
    FeaturedSwiper: {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselOverlap")
        ),
        props: {
            slideClassName: "aspect-square",
            depth: 140,
            cropSize: 'square',
        }
    }, // TODO: style name to be changed
    RandomList: {
        Component: dynamic(() => import("@/components/InfiniteGallery")),
    }, // TODO: style name to be changed

    "BreakingNewsList": {
        Component: dynamic(() => import("@/components/BreakingNews/BreakingNewsPage")),
    },
    "SidebarList": {
        Component: dynamic(() => import("@/components/BreakingNews/SidebarList")),
    },
    "MediaGrid": {
        Component: dynamic(() => import("@/components/DetailsPage/CoverageSide")),
    },



    // articles
    "Articles/Featured": {
        Component: dynamic(() => import("@/components/NewsPage/FeatureSlider")),
        props: {
            showDescription: true,
        }
    },
    "Articles/Swiper": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            navigationDots: "top",
            author: true,
        },
    },
    mostRead: {
        Component: dynamic(() => import("@/components/MostReadCarousel")),
    },
    "Analysis/Featured": {
        Component: dynamic(() => import("@/components/TwoFeaturedPostsWidget")),
    },
    "Analysis/List": {
        Component: dynamic(() => import("@/components/AnalysisInfiniteGrid")),
    },
    "Features/Featured": {
        Component: dynamic(() => import("@/components/TwoFeaturedPostsWidget")),
    },
    "Features/List": {
        Component: dynamic(() => import("@/components/AnalysisInfiniteGrid")),
    },
    "Opinion/Featured": {
        Component: dynamic(() => import("@/components/OpinionsFeaturedWidget")),
    },
    "Opinion/List": {
        Component: dynamic(() => import("@/components/AnalysisInfiniteGrid")),
    },
    "Blog/MixedList": {
        Component: dynamic(() => import("@/components/BlogMixedListWidget")),
    },

    // ads
    verticalAd: {
        Component: dynamic(() => import("@/components/VerticalAd")),
    },
    "Banner/Horizontal": {
        Component: dynamic(() => import("@/components/Banners/HorizontalBanner")),
    },
    "Banner/Vertical": {
        Component: dynamic(() => import("@/components/Banners/VerticalBanner")),
    },

    "page-title": {
        Component: dynamic(() => import("@/components/TitleWidget")),
    },
    "page-title/newsfeed": {
        Component: dynamic(() => import("@/components/NewsfeedTitleWidget")),
    },
    "page-title/in-pictures-infographs": {
        Component: dynamic(() => import("@/components/InPicturesInfographsTitleWidget")),
    },

    // videos
    "Videos/Featured": {
        Component: dynamic(() => import("@/components/VideosMainFeatured")),
    },
    "Videos/Explainers": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            cropSize: "vertical",
            navigationDots: "top, sides",
            showTitle: false,
        },
    },
    "Videos/NewsFeed": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            cropSize: "vertical",
            navigationDots: "top, sides",
            showTitle: false,
        },
    },
    "Video/Features": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            cropSize: "square",
            navigationDots: "top, sides",
            slidesPerView: 3,
            showTitle: false,
        },
    },
    "Videos/TV": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            cropSize: "rectangle",
            navigationDots: "top, sides",
            showTitle: false,
            slidesPerView: 3
        },
    },
    "Videos/DigitalSeries": {
        Component: dynamic(
            () => import("@/components/DigitalSeriesCarousel")
        ),
    },
    "Explainer/Slider": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselOverlap")
        ),
        props: {
            cropSize: "vertical",
            useReelImage: true
        },
    },
    "Explainers/List": {
        Component: dynamic(() => import("@/components/ExplainersInfiniteList")),
    },
    "Newsfeed/Featured": {
        Component: dynamic(() => import("@/components/NewsPage/FeatureSlider")),
        props: {
            showTitle: false,
            showDescription: true,
            variant: "video",
            itemsPerRowMobile: 2,
        },
    },
    "NewsFeed/ListByDate": {
        Component: dynamic(() => import("@/components/NewsfeedListByDate")),
    },
    "Video/Details": {
        Component: dynamic(() => import("@/components/VideoDetails")),
    },
    "Video/TVDetails": {
        Component: dynamic(() => import("@/components/VideoDetails")),
        props: {
            showDate: false,
        }
    },
    "Videos/WatchNext": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
    },
    "Videos/Features/Featured": {
        Component: dynamic(() => import("@/components/NewsPage/FeatureSlider")),
        props: {
            showTitle: false,
            showDescription: true,
            variant: "video",
        },
    },
    "Videos/Features/List": {
        Component: dynamic(() => import("@/components/VideoNewsFeedGrid")),
        props: {
            itemsPerRow: 2,
            itemsPerRowMobile: 1,
            cropSize: "rectangle",
        },
    },
    FeaturedTV: {
        Component: dynamic(() => import("@/components/FeaturedTV")),
    },
    "Episodes/List": {
        Component: dynamic(() => import("@/components/EpisodesList")),
    },
    "TVShowEpisodes": {
        Component: dynamic(() => import("@/components/List")),
        props: {
            orientation: "vertical",
            priority: "half",
            itemsPerGridMobile: 2,
            cropSize: "rectangle"
        }
    },
    "DocumenteriesList": {
        Component: dynamic(() => import("@/components/List")),
        props: {
            orientation: "horizontal",
            itemsPerGrid: 1,
            summaryClassName: "text-base mt-2 lg:mt-0 lg:text-xs !line-clamp-4",
            itemsPerGridMobile: 1,
            alignContent: "end",
            showDate: true
        }
    },
    "InFive": {
        Component: dynamic(() => import("@/components/List")),
        props: {
            orientation: "vertical",
            priority: "half",
            itemsPerGridMobile: 2,
            cropSize: "rectangle",
            showTitle: true
        }
    },
    InfographDetails: {
        Component: dynamic(() => import("@/components/InfographDetails")),
    },
    InPicturesDetails: {
        Component: dynamic(() => import("@/components/InPicutersDetails")),
    },

    "Regions/Articles": {
        Component: dynamic(() => import("@/components/shared/Grids/BlockGrid")),
    },
    "Regions/News": {
        Component: dynamic(() => import("@/components/RegionsNewsGrid")),
        props: {
            itemsPerRow: 4,
        },
    },

    "Regions/Videos": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            navigationDots: "top",
            backgroundImage: "/images/videosbg.jpg",
            slidesPerView: 3,
            showTitle: false,
            className: "text-white",
            cropSize: "vertical",
            useReelImage: false,
        },
    },
    "Regions/InPictures": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            navigationDots: "top",
            showTitle: false,
            cropSize: "square",
            slidesPerView: 3,
        },
    },
    "Regions/Infograph": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            navigationDots: "top",
            slidesPerView: 3,
            showTitle: false,
            cropSize: "square",
        },
    },
    "Coverage/Banner": {
        Component: dynamic(
            () => import("@/components/CoverageBanner")
        )
    },
    "Coverage/Carousel": {
        Component: dynamic(
            () => import("@/components/shared/Carousel/CarouselWidget")
        ),
        props: {
            navigationDots: "top",
            showCategory: false,
            author: true
        },
    },
    "Coverage/InPictures": {
        Component: dynamic(
            () => import("@/components/InPicturesSectionCoverage")
        ),
    },
    "Coverage/Infograph": {
        Component: dynamic(
            () => import("@/components/InPicturesSectionCoverage")
        ),
    },
    "Coverage/Articles": {
        Component: dynamic(
            () => import("@/components/EpisodesGrid")
        ),
        props: {
            showTitle: true,
            variant: "opened",
            showAuthor: true
        },
    },
    "Coverage/Videos/Featured": {
        Component: dynamic(() => import("@/components/CoverageVideoFeatured")),
    },
    "Details/ForYou": {
        Component: dynamic(
            () => import("@/components/ElasticRelatedGrid")
        ),
        props: {
            itemsPerRow: 4,
            author: false
        }
    },

    "banner-image": {
        Component: dynamic(() => import("@/components/BannerImage")),
    },

    "region-banner": {
        Component: dynamic(() => import("@/components/RegionBanner")),
    },

    "DigitalSeries/In5": {
        Component: dynamic(() => import("@/components/DigiralSeriesFeatured")),
    },
    "DigitalSeries/Figures": {
        Component: dynamic(() => import("@/components/DigiralSeriesFeatured")),
    },


    // author
    "Authors/List": {
        Component: dynamic(() => import("@/components/Authors/List")),
    },
    "author/Details": {
        Component: dynamic(() => import("@/components/AuthorDetails/Details")),
    },
    "author/relatedPosts": {
        Component: dynamic(() => import("@/components/AuthorDetails/ArticlesList")),
    },
    
    // live
    "LivePlayer": {
        Component: dynamic(() => import("@/components/Live/Live")),
    },

    // static pages (ex about, privacy policy)
    "page-static": {
        Component: dynamic(() => import("@/components/StaticPage")),
    },

    "live-video": {
        Component: dynamic(() => import("@/components/LiveVideo")),
    },

    "EpisodesGrid": {
        Component: dynamic(() => import("@/components/EpisodesGrid")),
    },
    "DefaultList": {
        Component: dynamic(
            () => import("@/components/EpisodesGrid")
        ),
        props: {
            showTitle: true,
            variant: "opened",
            showSummary: false
        },
    },
};

export default widgetStylesRegistry;
